export { default as DeletedCard } from './DeletedCard';



// WEBPACK FOOTER //
// ./src/components/AdCard/DeletedCard/index.ts